export default {
  container: 'flex flex-row gap-[24px] py-[18px] px-[14px] bg-color-white rounded-xl',
  image: 'w-[56px]',
  text: 'font-interMedium text-[16px] text-color-text sm:text-[18px] sm:leading-[26px]',
};
